var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnfluenceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16320_23199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.872795 18.0567C0.614143 18.4648 0.360251 18.8759 0.11117 19.2899C-0.10558 19.6523 0.00279502 20.1239 0.365045 20.3418L5.33079 23.3887C5.69342 23.6062 6.16386 23.4968 6.38155 23.1346C6.61471 22.7185 6.85639 22.3072 7.10642 21.901C9.0643 18.6736 11.0572 19.036 14.609 20.7412L19.539 23.0613C19.9372 23.2432 20.3728 23.0613 20.5534 22.6988L22.91 17.3682C23.0906 17.0048 22.91 16.5342 22.5465 16.3523C21.4957 15.8806 19.4306 14.9011 17.618 13.9949C10.913 10.7663 5.22167 10.9842 0.87317 18.0567H0.872795Z",
    fill: "url(#paint0_linear_16320_23199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1271 5.94339C23.3858 5.5353 23.6397 5.12421 23.8889 4.7102C24.1064 4.34776 23.9971 3.8762 23.6348 3.65833L18.6691 0.611451C18.3066 0.393951 17.836 0.503264 17.6183 0.865514C17.3856 1.28183 17.144 1.69311 16.8936 2.09908C14.9356 5.32651 12.9426 4.96408 9.39081 3.25895L4.46087 0.938826C4.06262 0.756951 3.62818 0.938826 3.4465 1.30126L1.09075 6.63189C0.909245 6.99526 1.09075 7.46701 1.45318 7.64776C2.50393 8.11951 4.57018 9.09901 6.38162 10.0052C13.0879 13.1978 18.7782 13.0157 23.1267 5.94339H23.1271Z",
    fill: "url(#paint1_linear_16320_23199)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16320_23199",
    x1: 22.7907,
    y1: 24.9669,
    x2: 7.79181,
    y2: 16.3549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16320_23199",
    x1: 1.2091,
    y1: -0.976685,
    x2: 16.208,
    y2: 7.63628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16320_23199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnfluenceIcon);
export default __webpack_public_path__ + "static/media/СonfluenceIcon.c4b00eeeeef813e01085a809181a3153.svg";
export { ForwardRef as ReactComponent };